"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  root: {
    '& .MuiPaper-root': {
      border: '1px solid #EFEFEF',
      borderRadius: '10px',
      // backgroundColor: '#fff',
      boxShadow: 'none'
    }
  }
};